<template>
    <RcuCheck />
</template>

<script>
  import RcuCheck from '@/components/ask/pages/RcuCheck.vue'

  export default {
    name: 'PageRcuCheck',

    components:{
      RcuCheck
    },
  
    data(){
      return {
      
      }
    },

    created(){
      
    },

    mounted(){
    //   this.$eventBus.emit('page-change', {
    //     target: this,
    //     currentRoute: this.$router.currentRoute.value
    //   })
    },

    methods:{

    },
  }
</script>

<style>

</style>
